var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6663,
    height: 865,
    viewBox: "0 0 6663 865",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2172 431.753L2309.57 431.753C2309.57 594.609 2441.55 726.639 2604.35 726.639C2767.15 726.639 2899.13 594.609 2899.13 431.753L2899.17 431.753C2899.56 193.249 3092.94 6.08833e-05 3331.52 8.17405e-05C3570.1 0.000102598 3763.87 193.642 3763.87 432.5C3763.87 595.356 3895.81 727.386 4058.65 727.386C4221.49 727.386 4353.43 595.356 4353.43 432.5L4491 432.5C4491 671.358 4297.43 865 4058.65 865C3819.88 865 3626.3 671.358 3626.3 432.5C3626.3 269.644 3494.32 137.614 3331.52 137.614C3168.72 137.614 3036.74 269.644 3036.74 432.5L3036.7 432.5C3036.3 671.004 2842.93 864.253 2604.35 864.253C2365.77 864.253 2172 670.611 2172 431.753Z",
    fill: "url(#paint0_linear_3002_7092)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6663 433.247H6526.03C6526.03 270.391 6394.61 138.361 6232.52 138.361C6070.42 138.361 5939 270.391 5939 433.247H5938.96C5938.57 671.751 5746.03 865 5508.48 865C5270.93 865 5078 671.358 5078 432.5C5078 269.644 4946.62 137.614 4784.48 137.614C4622.35 137.614 4490.97 269.644 4490.97 432.5H4354C4354 193.642 4546.74 0 4784.48 0C5022.23 0 5214.97 193.642 5214.97 432.5C5214.97 595.356 5346.38 727.386 5508.48 727.386C5670.58 727.386 5801.99 595.356 5801.99 432.5H5802.03C5802.42 193.996 5994.97 0.747045 6232.52 0.747045C6470.06 0.747045 6663 194.389 6663 433.247Z",
    fill: "url(#paint1_linear_3002_7092)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2309 433.247H2172.03C2172.03 270.391 2040.61 138.361 1878.52 138.361C1716.42 138.361 1585 270.391 1585 433.247H1584.96C1584.57 671.751 1392.03 865 1154.48 865C916.931 865 723.996 671.358 723.996 432.5C723.996 269.644 592.62 137.614 430.484 137.614C268.348 137.614 136.972 269.644 136.972 432.5H0C0 193.642 192.74 0 430.484 0C668.229 0 860.969 193.642 860.969 432.5C860.969 595.356 992.384 727.386 1154.48 727.386C1316.58 727.386 1447.99 595.356 1447.99 432.5H1448.03C1448.42 193.996 1640.97 0.747045 1878.52 0.747045C2116.06 0.747045 2309 194.389 2309 433.247Z",
    fill: "url(#paint2_linear_3002_7092)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3002_7092",
    x1: 3020.77,
    y1: -265,
    x2: 3784.82,
    y2: 556.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0169713,
    stopColor: "#003413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567228,
    stopColor: "#D2E0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3002_7092",
    x1: 5817.89,
    y1: 1130,
    x2: 5053.61,
    y2: 311.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0169713,
    stopColor: "#003413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567228,
    stopColor: "#D2E0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3002_7092",
    x1: 1463.89,
    y1: 1130,
    x2: 699.611,
    y2: 311.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0169713,
    stopColor: "#003413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567228,
    stopColor: "#D2E0A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.085f76e6decb77d9b2423a31160552ca.svg";
export { ForwardRef as ReactComponent };